// Helpers de fecha para reemplazar antd <DatePicker> por
// <input type="date"> / <input type="datetime-local"> nativos + clase "form-control".
// Sin dependencias externas (no dayjs/moment).

const pad = (n) => String(n).padStart(2, "0");

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

// Date | string | null -> "YYYY-MM-DD" (valor esperado por <input type="date">)
export function toDateInputValue(value) {
  const d = toDate(value);
  if (!d) return "";
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

// Date | string | null -> "YYYY-MM-DDTHH:mm" (valor esperado por <input type="datetime-local">)
export function toDateTimeInputValue(value) {
  const d = toDate(value);
  if (!d) return "";
  return `${toDateInputValue(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// "YYYY-MM-DD" (evento de <input type="date">) -> Date (medianoche local) | null
export function fromDateInputValue(str) {
  if (!str) return null;
  const [y, m, d] = str.split("-").map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

// "YYYY-MM-DDTHH:mm" (evento de <input type="datetime-local">) -> Date | null
export function fromDateTimeInputValue(str) {
  if (!str) return null;
  const d = new Date(str);
  return isNaN(d.getTime()) ? null : d;
}

// Date | string | null -> "DD/MM/YYYY"
export function formatDisplayDate(value) {
  const d = toDate(value);
  if (!d) return "";
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

// Date | string | null -> "DD/MM/YYYY HH:mm"
export function formatDisplayDateTime(value) {
  const d = toDate(value);
  if (!d) return "";
  return `${formatDisplayDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

const MESES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

// Date | string | null -> "3 de agosto de 2026, 14:30" (formato largo en español)
export function formatLongSpanishDateTime(value) {
  const d = toDate(value);
  if (!d) return "";
  return `${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
